/**
 * Справочники СОУТ — дословный канон из прототипа `sout.html` (IC-2, план фазы 2, реш. 8).
 * Значения переносить БЕЗ изменений: они закреплены как пиннинг формы места и переиспользуются
 * визардом (IC-3, `sout-wizard.tsx`) — не редактировать по месту использования, только здесь.
 */

/**
 * График работы места (`sout.html` `SCHEDULES`, 7 значений) — ЗНАЧЕНИЯ (хранятся в снимке,
 * сравниваются в `resolveScheduleDisplay`/back-compat) остаются дословным каноном IC-2, не
 * меняются задним числом. «Иной» → показывает `scheduleOther`.
 *
 * p3-sout-workplaces §7 (Волна 6): ТЗ `Правки_2_для_разработчика.md` дословно требует
 * ОТОБРАЖАТЬ значения строчными («сутки через трое», «сменный», …) — приоритет текста ТЗ над
 * старым макетом/скриншотом (Resolved №4). Меняем только ВИДИМУЮ подпись пункта списка через
 * `SCHEDULE_OPTION_LABELS` ниже — хранимое значение (`value` пункта, сравнение со SCHEDULES)
 * не трогаем, иначе сломаем back-compat старых черновиков (`resolveScheduleDisplay`).
 */
export const SCHEDULES = ['5/2', '2/2', 'Сутки через трое', 'Сменный', 'Гибкий', 'Вахтовый', 'Иной'] as const

/** Видимая подпись пункта списка «График работы» (§7, ТЗ дословно) — см. комментарий SCHEDULES. */
export const SCHEDULE_OPTION_LABELS: Record<(typeof SCHEDULES)[number], string> = {
  '5/2': '5/2',
  '2/2': '2/2',
  'Сутки через трое': 'сутки через трое',
  Сменный: 'сменный',
  Гибкий: 'гибкий',
  Вахтовый: 'вахтовый',
  Иной: 'иной',
}

/** Класс условий труда по прошлой СОУТ/АРМ (`sout.html` `PREV_CLASSES`, 8 значений). */
export const PREV_CLASSES = ['Не проводилось', '1', '2', '3.1', '3.2', '3.3', '3.4', '4'] as const

/**
 * Тяжесть несчастного случая (`sout.html` `ACCIDENT_SEVERITIES`, 3 значения) — ЗНАЧЕНИЯ
 * (хранятся в снимке) дословно из канона IC-2 (без «ё»): «Легкий», не «Лёгкий». Дефолт новой
 * записи — «Легкий».
 *
 * p3-sout-workplaces §10 (Волна 6): текст ТЗ дословно требует «Лёгкий»/«Тяжёлый» (с «ё») —
 * приоритет текста над скриншотом/старым каноном (Resolved №4). Меняем только ВИДИМУЮ подпись
 * через `ACCIDENT_SEVERITY_LABELS` ниже, хранимое значение не трогаем (back-compat со старыми
 * снимками/бэкендовым дефолтом `soutAccidentSeverityDefault = "Легкий"`, который не входит в
 * объём этой — фронтовой — волны).
 */
export const ACCIDENT_SEVERITIES = ['Легкий', 'Тяжелый', 'Смертельный'] as const

/** Видимая подпись пункта списка «Тяжесть» (§10, ТЗ дословно) — см. комментарий выше. */
export const ACCIDENT_SEVERITY_LABELS: Record<(typeof ACCIDENT_SEVERITIES)[number], string> = {
  Легкий: 'Лёгкий',
  Тяжелый: 'Тяжёлый',
  Смертельный: 'Смертельный',
}

/*
 * COMMON_POSITIONS удалён (p2-position-dictionary, Волна 3): должность теперь — строгий выбор
 * из глобального справочника `GET /api/positions` через combobox `PositionSelect`. Канонический
 * список должностей перенесён в seed миграции 00020 (backend), фронт-константа больше не нужна.
 * COMMON_DEPARTMENTS удалён (p3-critical-fixes №4): подразделение в форме РМ — свободный текст
 * без datalist-подсказок (решение РП); справочника подразделений нет.
 */
